module.exports = __webpack_public_path__ + "static/img/dy_qrcode.438ade1e.png";